import { gql, TypedDocumentNode, ApolloLink, ApolloCache } from '@apollo/client';
import { ADDRESS_FRAGMENT, RestAddress } from '../fragments.rest';

export type AddressesQuery = {
  addresses: {
    __typename: 'RestAddresses';
    data: RestAddress[];
  };
};

export const ADDRESSES_QUERY: TypedDocumentNode<AddressesQuery, Record<string, never>> = gql`
  query AddressesQuery {
    addresses @rest(type: "RestAddresses", endpoint: "user", path: "/v1/addresses", method: "GET") {
      data @type(name: "RestAddress") {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`;

export const updateAddressesCache = (
  cache: Pick<ApolloCache, 'readQuery' | 'writeQuery'>,
  result: ApolloLink.Result,
  id?: string
) => {
  if (result.errors) {
    return;
  }

  const data = cache.readQuery({
    query: ADDRESSES_QUERY
  });

  if (!data) {
    return;
  }

  const writeQuery = (addresses: RestAddress[]) =>
    cache.writeQuery({
      query: ADDRESSES_QUERY,
      data: {
        ...data,
        addresses: {
          data: addresses,
          __typename: 'RestAddresses'
        }
      }
    });

  const cachedAddresses = [...data.addresses.data];

  const createdAddress: RestAddress | undefined = result.data?.createAddress?.data;
  if (createdAddress) {
    writeQuery([createdAddress, ...cachedAddresses]);
  } else if (result.data?.deleteAddress) {
    writeQuery(cachedAddresses.filter(address => address.id !== id));
  }
};
